<div class="">
  <ng-container class="">
    <router-outlet></router-outlet>
  </ng-container>
  <network-block-modal></network-block-modal>
</div>
